<!-- =========================================================================================
    File Name: TechnicAddNew.vue
    Description: Add new technic component
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div data-backdrop="static" id="technicAddNew">
    <vs-prompt
      name="serviskaydi"
      vs-title="Garaj Kaydı"
      vs-accept-text="Oluştur"
      vs-cancel-text="Vazgeç"
      vs-button-cancel="border"
      @vs-cancel="cancel"
      @vs-accept="submitRegistiration"
      @vs-close="cancel"
      :vs-is-valid="validateFormService"
      :vs-active.sync="addNewRegister"
    >
      <div>
        <div class="vx-row mb-3 flex mb-5" style="justify-content: center;">
          <div class="vx-col">
            <vs-button color="darkgray" style="" type="filled" @click="popupObdReadForm = true">Connect To Vehicle</vs-button>
          </div>
        </div>
        <div class="vx-row mb-3 mt-3 flex">
          <div class="vx-col md:w-1/3 mt-3  w-full flex justify-end sm-btn">
            <vs-button color="warning" type="filled" @click="addNewCustomer">Müşteri Ekle</vs-button>
          </div>
          <div class="vx-col md:w-1/3 mt-3 w-full ">
            <vs-input name="musteriAd" icon-pack="feather" icon="icon-user" placeholder="Ara.." class="w-full" v-model="searchQuery" :color="validateFormService ? 'success' : 'warning'" @keyup="delayedSearch" />
          </div>
          <div class="vx-col md:w-1/3 mt-3 w-full">
            <vs-button type="border" @click="search()">Ara</vs-button>
          </div>
        </div>

        <!-- <div class="vx-row mb-3 flex">
          <div class="vx-col md:w-1/4 text-right">
            <vs-button color="danger" type="filled" @click="addNewCustomer">Müşteri Ekle</vs-button>
          </div>
          <div class="vx-col md:w-1/2 flex">
            <vs-input name="musteriAd" icon-pack="feather" icon="icon-user" placeholder="Ara.." class="w-full" v-model="searchQuery" :color="validateFormService ? 'success' : 'danger'" @keyup="delayedSearch" />

            <vs-button type="border" class="ml-5" @click="search()">Ara</vs-button>
          </div>
          <div class="vx-col md:w-1/4 flex"></div>
        </div> -->

        <div class="vx-row" id="tblSearchResultsContainer">
          <div class="vx-col w-full">
            <vs-table noDataText="Tabloda Veri Yok" :data="customerSearch">
              <template slot="thead">
                <vs-th hidden>id</vs-th>
                <vs-th class="md:w-1/3">Müşteri</vs-th>
                <vs-th class="md:w-1/6">Telefon</vs-th>
                <vs-th class="md:w-3/6">Adres</vs-th>
                <vs-th class="md:w-1/12">Seç</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="data[i].userId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td hidden :data="data[i].userId" class="pt-0 pb-1">{{ data[i].userId }}</vs-td>

                  <vs-td :data="data[i].firstName + ' ' + (data[i].lastName == null ? '' : data[i].lastName)" class="pt-0 pb-1">{{ data[i].firstName + " " + (data[i].lastName == null ? "" : data[i].lastName) }}</vs-td>

                  <vs-td :data="data[i].phone" class="pt-0 pb-1">
                    {{ data[i].phone }}
                  </vs-td>

                  <vs-td :data="data[i].address" class="pt-0 pb-1">
                    {{ data[i].address }}
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style>
                    <vs-button type="border" size="small" icon-pack="feather" icon="icon-check-square" color="success" @click="selectItem(i)"></vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>

      <!-- garage -->
      <div class="vx-col w-full" v-if="garageComes">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full  mt-5">
            <label>Müşteri Adı Soyadı</label>
            <vs-input disabled name="musteriAdSoyad" size="small" class="w-full mb-0" v-model="selectedCustomer.firstName" :color="validateFormService ? 'success' : 'danger'" />
          </div>
          <div class="vx-col md:w-1/2 w-full  mt-5">
            <label>Müşteri Telefonu</label>
            <vs-input disabled name="musteriTelefon" size="small" class="w-full mb-0" v-model="selectedCustomer.phone" :color="validateFormService ? 'success' : 'danger'" />
          </div>
        </div>
        <div class="vx-row ">
          <div class="vx-col md:w-1/2 w-full  mt-5">
            <label>Araç Plaka No</label>
            <vs-input v-validate="'required'" name="vehiclePlate" class="w-full mb-0" size="small" v-model="orderCreatingProperties.vehicle.plate" :color="validateFormService ? 'success' : 'danger'" />
            <span v-show="errors.has('vehiclePlate')" class="errorfonts">{{ errors.first("vehiclePlate") }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full  mt-5">
            <label>Araç Kategori</label>
            <v-select
              v-validate="'required'"
              name="vehicleCat"
              class="w-full mb-0"
              size="small"
              placeholder="Seçiniz"
              :options="vehicleDropDowns.categories"
              label="value"
              selected="1"
              v-model="cat"
              :color="validateFormService ? 'success' : 'danger'"
              @input="brand = ''"
            >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
            <span v-show="errors.has('vehicleCat')" class="errorfonts">{{ errors.first("vehicleCat") }}</span>
          </div>
        </div>

        <div class="vx-row ">
          <div class="vx-col md:w-1/2 w-full mt-5">
            <label>Motor Şasi No</label>
            <vs-input v-validate="'required'" name="engineNo" class="w-full mb-0" size="small" v-model="orderCreatingProperties.vehicle.engineNo" :color="validateFormService ? 'success' : 'danger'" />
            <span v-show="errors.has('engineNo')" class="errorfonts">{{ errors.first("engineNo") }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
            <label>Araç Marka</label>
            <v-select
              v-validate="'required'"
              class="w-full mb-0"
              name="brands"
              size="small"
              placeholder="Seçiniz"
              :options="vehicleDropDowns.brands"
              label="value"
              v-model="brand"
              :color="validateFormService ? 'success' : 'danger'"
              @input="orderCreatingProperties.vehicle.model = ''"
            >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
        </div>

        <div class="vx-row ">
          <div class="vx-col md:w-1/2 w-full mt-5">
            <label>VIN</label>
            <vs-input v-validate="'required'" name="vin" class="w-full mb-0" size="small" v-model="orderCreatingProperties.vehicle.vin" :color="validateFormService ? 'success' : 'danger'" />
            <span v-show="errors.has('vin')" class="errorfonts">{{ errors.first("vin") }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
            <label>Araç Model</label>
            <v-select
              v-validate="'required'"
              name="carModel"
              class="w-full mb-0"
              size="small"
              placeholder="Seçiniz"
              :disabled="!carSelection()"
              :options="carModels"
              label="value"
              v-model="orderCreatingProperties.vehicle.model"
              :reduce="(carModels) => carModels.id"
              :color="validateFormService ? 'success' : 'danger'"
            >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
        </div>

        <div class="vx-row ">
          <div class="vx-col md:w-1/2 w-full mt-3">
            <label>KM</label>
            <vs-input v-validate="'required|numeric'" name="mileage" class="w-full mb-0" size="small" v-model="orderCreatingProperties.vehicle.mileage" :color="validateFormService ? 'success' : 'danger'" />
            <span v-show="errors.has('mileage')" class="errorfonts">{{ errors.first("mileage") }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-3">
            <label>Araç Yakıt Türü</label>
            <v-select
              v-validate="'required'"
              class="w-full mb-0"
              name="fuelType"
              placeholder="Seçiniz"
              size="small"
              :options="fuelType"
              label="text"
              v-model="orderCreatingProperties.vehicle.fuel"
              :reduce="(fuelType) => fuelType.value"
              :color="validateFormService ? 'success' : 'danger'"
            >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-2">
            <label>Model Yılı</label>
            <vs-input name="modelYear" v-validate="'numeric'" size="small" class="w-full mb-0" v-model="orderCreatingProperties.vehicle.modelYear" :color="validateFormService ? 'success' : 'danger'" />
            <span v-show="errors.has('modelYear')" class="errorfonts">{{ errors.first("modelYear") }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2">
            <label>Fiş No</label>
            <vs-input v-validate="'required'" name="documentNumber" class="w-full mb-0" size="small" v-model="orderCreatingProperties.vehicle.documentNumber" :color="validateFormService ? 'success' : 'danger'" />
          </div>
        </div>

        <div class="vx-row ">
          <div class="vx-col md:w-1/2 w-full mt-2">
            <label>Motor Hacmi</label>
            <vs-input v-validate="'numeric'" name="engineCapacity" size="small" class="w-full mb-0" v-model="orderCreatingProperties.vehicle.engineCapacity" :color="validateFormService ? 'success' : 'danger'" />
            <span v-show="errors.has('engineCapacity')" class="errorfonts">{{ errors.first("engineCapacity") }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2">
            <label>Motor Gücü</label>
            <vs-input name="horsePower" v-validate="'numeric'" class="w-full mb-0" size="small" v-model="orderCreatingProperties.vehicle.horsePower" :color="validateFormService ? 'success' : 'danger'" />
            <span v-show="errors.has('horsePower')" class="errorfonts">{{ errors.first("horsePower") }}</span>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-2">
            <label>Servis Kayıt Tarihi</label>
            <input :disabled="!isAdmin()" class="w-full mb-2 mt-0" type="datetime-local" v-model="orderCreatingProperties.recordDate" name="arrangementDate" @change="isValid($event, '', 'red')" />

            <!-- <flat-pickr
              v-validate="'required'"
              :config="configdateTimePicker"
              name="configdateTimePicker"
              class="w-full mb-0 mt-1"
              :disabled="!isAdmin()"
              v-model="orderCreatingProperties.recordDate"
              :color="validateFormService ? 'success' : 'danger'"
            /> -->
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2">
            <label>Araç Teslim Tarihi</label>
            <input class="w-full mb-2 mt-0" type="datetime-local" v-model="orderCreatingProperties.deliveryDate" name="arrangementDate" @change="isValid($event, '', 'red')" />

            <!-- <flat-pickr
              :config="configdateTimePicker"
              v-validate="'required'"
              name="serviceRegisterDate"
              class="w-full mb-0 mt-1"
              v-model="orderCreatingProperties.deliveryDate"
              :color="validateFormService ? 'success' : 'danger'"
            /> -->
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <vs-textarea
              v-validate="'required'"
              name="customerAccessory"
              label="Cihaz Aksesuar"
              class="w-full mb-0 mt-5"
              placeholder="Müşterinin cihazla beraber getirdiği aksesuarlar"
              v-model="orderCreatingProperties.accesories"
              :color="validateFormService ? 'success' : 'danger'"
            />
            <span v-show="errors.has('customerAccessory')" class="errorfonts">{{ errors.first("customerAccessory") }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vs-textarea
              v-validate="'required'"
              name="customerComplaint"
              label="Müşterinin cihazdan şikayeti"
              class="w-full mb-0 mt-5"
              placeholder="Müşteri Şikayeti"
              v-model="orderCreatingProperties.customerNote"
              :color="validateFormService ? 'success' : 'danger'"
            />
            <span v-show="errors.has('customerComplaint')" class="errorfonts">{{ errors.first("customerComplaint") }}</span>
          </div>
        </div>
      </div>
      <!-- !garage -->
    </vs-prompt>

    <add-new-customer :addnew="addNewCust" v-if="addNewCust" :withAdditionalData="false" @hideAddNewRegister="hideAddNewCust"></add-new-customer>

    <vs-prompt
      style="z-index: 100001;"
      :vs-title="Object.keys(canBusData).length === 0 ? ' DTC Okuma  Ekranı ' : canBusData[0].deviceSerialCode + ' Seri Kodlu Cihazdan Okuma Yapıyor'"
      vs-accept-text="Arıza Kodlarını Al"
      vs-cancel-text="İptal"
      vs-button-cancel="border"
      :vs-active.sync="popupObdReadForm"
      :vs-buttons-hidden="true"
      @vs-accept="SaveObdReadData()"
      @vs-cancel="
        popupObdReadForm = false;
        StopCanbusDataRead();
      "
      @vs-close="StopCanbusDataRead()"
    >
      <div class="flex" style="justify-content: center;">
        <vs-button type="filled" v-if="!deviceReadStarted" color="darkgray" class="mr-2" @click="StartCanbusDataRead()">Listen Device</vs-button>

        <vs-button type="filled" v-if="deviceReadStarted" class="mr-2" color="danger" @click="StopCanbusDataRead()">Stop Listening</vs-button>

        <vs-button type="filled" v-if="!deviceReadStarted" class="mr-2" @click="GetCarCanbusData()">One Time Listen</vs-button>
      </div>
      <div class="flex mt-5" v-if="deviceReadStarted" style="justify-content: center;">
        <vs-progress style="width: 100%;" indeterminate color="primary">primary</vs-progress>
      </div>

      <div class="vx-row ml-5 mr-5 flex" style="margin-top: 30px; margin-bottom: 99px;">
        <div class="vx-row w-full">
          <div class="vx-col" style="width: 150px;">
            <b> Tarih</b>
          </div>

          <div class="vx-col" style="width: 200px;">
            <b> VIN</b>
          </div>
          <!-- <div class="vx-col" style="width:130px">
            <b>CanId</b>
          </div> -->
          <!-- <div class="vx-col  " style="width:150px">
            <b>Raw D Value</b>
          </div> -->
          <div class="vx-col" style="width: 200px;">
            <b> DTC Forum</b>
          </div>
          <div class="vx-col" style="width: 450px;">
            <b> DTC Description </b>
          </div>

          <div class="vx-col" style="width: 100px;">
            <b> Ekle </b>
          </div>
        </div>

        <div v-for="item in canBusData" :key="item.carCanbusDataId" class="vx-row mt-5">
          <div class="vx-col" style="width: 150px; overflow-wrap: anywhere;">
            {{ item.date }}
          </div>

          <div class="vx-col" style="width: 200px;">
            {{ item.vin }}
          </div>

          <!-- <div class="vx-col  " style="width:130px">
            {{ item.canId }}
          </div> -->
          <!-- <div class="vx-col  " style="overflow-wrap: anywhere;width:150px">
            {{ item.rawData }}
          </div> -->
          <div class="vx-col" style="width: 200px;">
            <a :href="'http://www.google.com/search?q=site:forum.nitrobilisim.com.tr ' + item.dtc" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"
              ><b>{{ item.dtc }} </b></a
            >
          </div>
          <div class="vx-col" style="width: 450px; overflow-wrap: anywhere;">
            {{ item.dtcDescription }}
          </div>

          <div class="vx-col" style="width: 100px; align-self: center;">
            <vs-button size="small" class="mr-2" color="danger" @click="SetCanbus()">Kaydet&Kapat</vs-button>
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import "flatpickr/dist/flatpickr.css";
import { repository } from "@/_services/repository.js";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import { Validator } from "vee-validate";
import addNewCustomer from "../contacts/addNewPrompt.vue";

const dict = {
  custom: {
    modelYear: {
      numeric: "Lütfen sayı giriniz",
    },
    vehiclePlate: {
      required: "Araç plakası zorunludur!",
    },
    vehicleCat: {
      required: "Araç Kategorisi zorunludur!",
    },
    engineNo: {
      required: "Araç Motor No zorunludur!",
    },
    vin: {
      required: "Araç VIN zorunludur!",
    },
    mileage: {
      required: "Araç KM zorunludur!",
      numeric: "Lütfen sayı giriniz",
    },
    engineCapacity: {
      numeric: "Lütfen sayı giriniz",
    },
    horsePower: {
      numeric: "Lütfen sayı giriniz",
    },
    customerAccessory: {
      required: "Aksesuar Bilgisi Giriniz",
    },
    customerComplaint: {
      required: "Şikayet Bilgisi Giriniz",
    },
  },
};
Validator.localize("tr", dict);

export default {
  components: {
    flatPickr,
    vSelect,
    VueUploadMultipleImage,
    addNewCustomer,
  },
  props: {
    addnew: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      ///
      deviceReadStarted: false,
      deviceSerialCode: null,
      popupObdReadForm: false,
      obdDiagnosticDescription: null,
      canBusData: [],
      ///

      fuelType: [
        { text: "Dizel", value: "dizel" },
        { text: "Benzin", value: "benzin" },
        { text: "Lpg", value: "lpg" },
      ],
      currentServiceType: "",
      ownedDevices: [],
      addNewCust: false,
      delayedSearchTimer: null,
      vehicleDropDowns: [],
      garageComes: true,
      currentDeviceBarcode: null,
      currentProductBrand: "",
      currentProductModel: "",
      barcodelessDevices: [],
      customerSearch: [],
      searchQuery: "",
      cat: null,
      brand: null,
      barcodeProductSelection: true,
      serviceStatus: [],
      selectedCustomer: {},
      productSelection: [],
      imageList: [],

      orderCreatingProperties: {},

      configdateTimePicker: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
      },
      activeDeviceFeatures: false,
    };
  },
  computed: {
    getDate() {
      let d = new Date();
      d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
      return d.toISOString().substr(0, 16);
    },
    carModels() {
      try {
        if (this.cat != null && typeof this.cat["id"] != undefined && !isNaN(parseInt(this.cat.id))) {
          if (this.brand != null && typeof this.brand["id"] != undefined && !isNaN(parseInt(this.brand.id))) {
            if (this.carSelection()) if (this.vehicleDropDowns.models != null && typeof this.vehicleDropDowns.models == "object") return this.vehicleDropDowns.models.filter((x) => x.brandId == this.brand.id && x.categoryId == this.cat.id);
          }
        }
      } catch (e) {
        console.warn("carModels"), e;
      }
      return [];
    },
    addNewRegister: {
      get() {
        return this.addnew;
      },
      set() {},
    },
    validateFormService() {
      return new Date(this.orderCreatingProperties.recordDate) < new Date(this.orderCreatingProperties.deliveryDate);
    },
  },

  methods: {
    isValid(event, success, fail) {
      if (event instanceof Event) {
        if (event["target"] && event.target instanceof HTMLInputElement) {
          let e = document.getElementsByName(event.target.name);
          if (this.isDateTime(event)) {
            if (e && e[0]) {
              e[0].style["color"] = success;
            }
          } else {
            if (e && e[0]) e[0].style["color"] = fail;
          }
        }
      }
      return false;
    },
    isDateTime(d) {
      if (d instanceof Date) {
        return !isNaN(d);
      }
      if (typeof d === "string") {
        return this.isDateTime(new Date(d));
      }
      if (d instanceof Event) {
        if (d["target"] && d.target instanceof HTMLInputElement) return this.isDateTime(new Date(d.target.value));
      }
    },
    delayedSearch() {
      if (this.delayedSearchTimer) {
        clearTimeout(this.delayedSearchTimer);
        this.delayedSearchTimer = null;
      }
      this.delayedSearchTimer = setTimeout(() => {
        if (this.searchQuery && this.searchQuery.length > 3) this.search();
      }, 500);
    },
    //müşteriler sayfasından ekleme paneli
    addNewCustomer() {
      this.addNewCust = true;
    },
    hideAddNewCust() {
      this.addNewCust = false;
    },
    //başlangıcta veri içeriğini belirlemek için kullandık lifecycleda bir problemden ötürü
    initProp() {
      this.orderCreatingProperties = {
        userId: 0,
        serviceType: 4,
        customerId: 0,
        customerNote: "",
        DbOrderLineType: [],
        orderTotal: 0,
        accesories: "",
        orderdiscount: 0,
        recordDate: "",
        deliveryDate: "",
        BarcodelessTable: [],
        vehicle: {
          id: 0,
          plate: "",
          fuel: "",
          model: "",
          vin: "",
          engineNo: "",
          mileage: "",
          engineCapacity: "",
          horsePower: "",
          documentNumber: "",
          modelYear: "",
        },
      };
      return this.orderCreatingProperties;
    },
    //garaj girişinde araçların kategori ve marka seçimine göre model seçilimi
    carSelection() {
      if (this.cat != null && this.brand != null) {
        return true;
      } else return false;
    },
    openDeviceSelectionPopup: async function() {
      if (!this.activeDeviceFeatures) {
        await this.getCustomerProducts();
        this.activeDeviceFeatures = true;
      } else {
        this.$vs.notify({
          title: " Hata!!!!",
          text: "Veriler yüklenene kadar lütfen bekleyiniz...",
          color: "primary",
        });
      }
    },
    //uploader methods
    uploadImageSuccess(formData, index, fileList) {
      this.imageList = fileList;
    },
    beforeRemove(index, done, fileList) {
      console.warn(fileList);
      done();
    },
    editImage(formData, index, fileList) {
      console.warn(fileList);
    },
    //müşteri arama sonucu listelenen kişilerden seçim yapılması
    selectItem(i) {
      if (!this.customerSearch[i].isReadyForInvoice) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: this.customerSearch[i].error,
        });
        return;
      }
      this.selectedCustomer = JSON.parse(JSON.stringify(this.customerSearch[i]));
      if (this.selectedCustomer.lastName != null) {
        this.selectedCustomer.firstName = this.selectedCustomer.firstName + " " + this.selectedCustomer.lastName;
      }
      this.orderCreatingProperties.customerId = this.selectedCustomer.customerId;
    },

    //müşteri arama
    search: async function() {
      this.customerSearch = await repository.getWithParam("Customer/search", "searchQuery=" + this.searchQuery).then((r) => r.list);
      if (this.customerSearch.length == 0) {
        this.$vs.notify({
          title: "Hata",
          text: "Böyle bir müşteri bulunamadı!",
          color: "danger",
        });
      }
      if (this.customerSearch && this.customerSearch.length == 1) this.selectItem(0);
      return this.customerSearch;
    },
    isAdmin() {
      return this.$store.state.userData.role === "Admin";
    },

    //servis kaydının vazgeçilerek kapanısı
    clearFields() {
      this.initProp();
      sessionStorage.removeItem("unfinishedGarageForm");
    },
    cancel() {
      sessionStorage.setItem("unfinishedGarageForm", JSON.stringify(this.orderCreatingProperties));
      this.$emit("hideAddNewRegister");
    },
    isAllValid: async function() {
      return await this.$validator.validateAll();
    },
    uploadImages: async function() {
      let x = await repository.postFile("Technic/createOrderFile", this.imageList, "_files");
      if (!x || x.hasExceptionError) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Fotoğraf(lar) yüklenirken bir hata oluştu",
        });
        return [];
      } else {
        return x.list;
      }
    },
    //emit fonksiyonun çalışmasını sağlamak için
    postModel: async function(postModel) {
      let images = await this.uploadImages();
      postModel.imageList = JSON.stringify(images);
      let r = await repository.postEntity("Technic/createOrder", postModel);
      if (r.isSuccessful) {
        this.$vs.notify({
          color: "success",
          icon: "done",
          title: "Tamamlandı",
          text: "Ekleme işlemi başarılı!",
        });
        return r;
        //return this.getNewItem(r.returnID);
      } else if (r.hasExceptionError) {
        this.$vs.notify({
          color: "danger",
          title: "İşlem tamamlanamadı!",
          text: r.exceptionMessage,
        });
      } else {
        this.$vs.notify({
          color: "danger",
          title: `Hata`,
          text: "Bilinmeyen bir hata sebebiyle işlem tamamlanamadı!",
        });
      }
      return null;
    },
    getNewItem: async function(_id) {
      let a = await repository.postEntity("technic/getOrders", {
        id: _id,
      });
      if (a.isSuccessful) {
        return a.list[0];
      } else return null;
    },
    //servis kaydının onaylanarak kapanısı
    submitRegistiration: async function() {
      let postSuccessful = false;

      if (!this.orderCreatingProperties.customerId || this.orderCreatingProperties.customerId <= 0) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Lütfen müşteri seçtiğinizden emin olunuz!",
        });
        return;
      }

      //garaj girişli teknik servis kayıt
      if (this.carModel == "") {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: `Araç seçiniz.`,
        });
        return;
      }
      //iki panel doldurulmussa garaj kaydında diğerini boşaltıyorum
      this.orderCreatingProperties.DbOrderLineType = [];
      this.orderCreatingProperties.orderTotal = 0;
      this.orderCreatingProperties.BarcodelessTable = [];
      this.orderCreatingProperties.orderdiscount = 0;
      this.orderCreatingProperties.serviceType = 4;

      let isvalid = await this.isAllValid();
      if (isvalid) {
        console.log(this.orderCreatingProperties);
        let r = await repository.postEntity("Technic/createOrder", this.orderCreatingProperties);
        if (r && r.isSuccessful) {
          postSuccessful = true;
          this.$vs.notify({
            color: "success",
            icon: "done",
            title: "Tamamlandı",
            text: r.returnID + "Ekleme işlemi başarılı!",
            fixed: true,
          });
          //message: "Alfa Romeo 33 undefined"
          repository.postEntity("General/pushNotification", {
            id: -1,
            title: "Sinyal - Yeni araç",
            message: this.brand.value,
            icon: "81",
            time: new Date(),
            category: "4",
            from: "0",
            to: "26", //26,40
            link: '{"name":"techServicePanel","id":"' + r.returnID + '"}',
          });
          repository.postEntity("General/pushNotification", {
            id: -1,
            title: "Sinyal - Yeni araç",
            message: this.brand.value,

            icon: "81",
            time: new Date(),
            category: "4",
            from: "0",
            to: "40", //26,40
            link: '{"name":"techServicePanel","id":"' + r.returnID + '"}',
          });

          let urun = this.orderCreatingProperties.vehicle.plate;
          postSuccessful = true;
          // let x = {
          //   serviceId: r.returnID,
          //   customerName: this.selectedCustomer.firstName,
          //   serviceStatus: "Yeni",
          //   serviceStatusId: 0,
          //   updatedDate: "1900-01-01T00:00:01",
          //   displayTransferProgress: false,
          //   status: true,
          //   transferStatus: -1,
          //   nextStatus:
          //     "[{'id':1,'value':'Beklemede'},{'id':2,'value':'Onarımda'},{'id':3,'value':'Tahsilat Bekliyor'},{'id':4,'value':'Teslimata Hazır'},{'id':5,'value':'Teslimatta'},{'id':6,'value':'Müşteri Dönüşü Bekleniyor'},{'id':97,'value':'Tamamlandı'},{'id':98,'value':'İade Edilecek'},{'id':99,'value':'İptal'}]",
          //   createdDate: new Date(),
          //   serviceType: "Garaj",
          //   serviceTypeId: 4,
          //   products: [{ productName: '[{"name":"' + urun + '"}]' }],
          //   assignedUser: this.$store.state.userData.userName,
          // };
          // this.$emit("addedData", x);
        } else if (r && r.hasExceptionError) {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: `${r.exceptionMessage}`,
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: "Bilinmeyen bir sebepten işlem tamamlanamadı!",
          });
        }
      }
      if (postSuccessful) {
        this.clearFields();
        this.$emit("hideAddNewRegister");
      }
    },
    getCustomerProducts: async function() {
      let mId = parseInt(this.orderCreatingProperties.customerId);
      if (isNaN(mId) || mId < 1) {
        return;
      }
      let x = await repository.getAll("Customer/getProductList?id=" + this.orderCreatingProperties.customerId);
      if (x && x.isSuccessful) {
        x = x.list;
        for (let i = 0; i < x.length; i++) {
          x[i].label = x[i].serialNumber ? "[ " + x[i].serialNumber + " ] " + x[i].product : x[i].product;
        }
        this.ownedDevices = x;
      }
    },
    //servis durumları çekilmesi
    getTechnicalServiceTypeList: async function() {
      let x = await repository.getAll("Technic/getTypeList?displayAll=false").then((r) => r.list);
      this.serviceStatus = x;
    },
    //veri tabanından araç marka model jategori çekilmesi
    getVehicleDropDown: async function() {
      let x = await repository.getAll("Technic/getVehicleDropDowns").then((r) => r.entity);
      localStorage.setItem("vehicleDropDowns", JSON.stringify(x));
      this.vehicleDropDowns = x;
    },
    getCustomerById(id) {
      if (id != 0) {
        repository.getById("Customer/getById", id).then((r) => {
          this.selectedCustomer = JSON.parse(JSON.stringify(r.list))[0];

          if (this.selectedCustomer.lastName != null) {
            this.selectedCustomer.firstName = this.selectedCustomer.firstName + " " + this.selectedCustomer.lastName;
          }
        });
      }
    },
    //yarım bırakılan arabanın marka model bulunması
    carFeatureGetter(d) {
      try {
        let a = JSON.parse(localStorage.getItem("vehicleDropDowns"));
        let modelObject = a.models.find((x) => x.id == d);
        this.cat = a.categories.find((x) => x.id == modelObject.categoryId);
        this.brand = a.brands.find((x) => x.id == modelObject.brandId);
      } catch (e) {
        console.warn("carFeatureGetter", e);
      }
    },

    // /////////////////////////////////////////CANBUS DATA OKUMA BÖLÜMÜ///////////////////////////////////////////////////////////////////////////////////////////////////////
    GetCarCanbusData: async function() {
      //this.$vs.loading();
      this.canBusData = await repository.postEntity("ResearchAndDevelopment/GetCarCanbusData", {}).then((r) => r.list);

      //this.$vs.loading.close();
    },

    StopCanbusDataRead: async function() {
      //this.$vs.loading();
      repository.clearTimer("CarCanbusData");
      //this.$vs.loading.close();
      this.deviceReadStarted = false;
    },
    StartCanbusDataRead: async function() {
      const a = setInterval(this.GetCarCanbusData, 1000);
      repository.timers(a, "CarCanbusData");
      this.deviceReadStarted = true;
    },
    // /////////////////////////////////////////CANBUS DATA OKUMA BÖLÜMÜ///////////////////////////////////////////////////////////////////////////////////////////////////////
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.$emit("hideDisplayPrompt", false);
      }
    });
  },
  created() {
    this.initProp();
    this.getTechnicalServiceTypeList();
    this.getVehicleDropDown();
    this.orderCreatingProperties.recordDate = this.getDate;
    let a = sessionStorage["unfinishedGarageForm"];

    if (repository.isJSON(a)) {
      a = JSON.parse(a);
      let b = this.orderCreatingProperties;
      let bKeys = Object.keys(b);
      let vKeys = Object.keys(b.vehicle);

      let control = true;

      //elimizdeki veri ile storagaden gelen karşılaşıtrılıyor
      for (let i = 0; i < bKeys.length; i++) {
        if (typeof a[bKeys[i]] == "undefined") {
          control = false;
          this.$vs.notify({
            title: "Uyarı !",
            text: "Yarım kalan kayıt işleminde veri kaybı yaşandı..",
            color: "warning",
            time: 4000,
            icon: "warning",
          });
          break;
        }
      }
      //elimizdeki verinin araç kısmı  ile storagaden gelen karşılaşıtrılıyor
      if (control) {
        for (let i = 0; i < vKeys.length; i++) {
          if (typeof a.vehicle[vKeys[i]] == "undefined") {
            control = false;
            break;
          }
        }
      }
      //elimizdeki veri tarih kısmı ile storagaden gelen karşılaşıtrılıyor
      if (control) {
        for (let i = 0; i < bKeys.length; i++) {
          if (JSON.stringify(a[bKeys[i]]) != JSON.stringify(b[bKeys[i]]) && bKeys[i].toLowerCase().indexOf("date") < 0) {
            control = false;
            break;
          }
        }
        if (control) return;

        let result = false;
        let xxx = () => {
          result = confirm(" Yarım kalan kayıt işlemine devam etmek ister misiniz ?");
        };
        xxx();
        if (result) {
          this.orderCreatingProperties = a;
          this.orderCreatingProperties.serviceType = 4;
          this.getCustomerById(this.orderCreatingProperties.customerId);

          if (this.orderCreatingProperties.serviceType == 4) {
            this.garageComes = true;
            if (this.orderCreatingProperties.vehicle.model != "") this.carFeatureGetter(this.orderCreatingProperties.vehicle.model);
          }
        }
        if (!result) {
          sessionStorage.removeItem("unfinishedGarageForm");
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.vs-dialog i.vs-dialog-cancel {
  top: 5px !important;
  right: 10px !important;
}
.vs__dropdown-toggle {
  height: 25px !important;
}
.vs__selected {
  height: 15px !important;
}
.vs__search {
  height: 15px !important;
}

.flatpickr-input {
  height: 15px !important;
}
.vs__dropdown-menu {
  max-height: 150px;
}
#heighter {
  .vs-con-table .vs-con-tbody {
    height: 185px;
  }
}
.v-dropdown-container {
  z-index: 9999999 !important ;
  width: 397px;
}
#multipleImage {
  font-family: "Times New Roman", Times, serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
  width: 100% !important;
}
.image-container {
  width: 100% !important;
}
.errorfonts {
  color: red;
}

@media screen and (max-width: 575px) {
  .sm-btn {
    justify-content: space-between !important;
  }
}
</style>
